import React from 'react';
import { Container } from 'react-bootstrap';

const LoadingSpinner = ({ message = "Loading..." }) => {
  return (
    <div className="loading-spinner">
      <Container className="text-center">
        <div className="spinner mb-3"></div>
        <p className="text-muted">{message}</p>
      </Container>
    </div>
  );
};

export default LoadingSpinner;